import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  brands: [],
  brandProducts: [],
  brand: {},
};

export const brandSlice = createSlice({
  name: 'brands',
  initialState,
  reducers: {
    setBrands: (state, action) => {
      state.brands = action.payload;
    },
    setBrand: (state, action) => {
      state.brand = action.payload.brand;
    },
    setBrandProducts: (state, action) => {
      state.brandProducts = action.payload.brandProducts;
    },
  },
});

export const { setBrands, setBrand, setBrandProducts } = brandSlice.actions;

export default brandSlice.reducer;
